import { render } from "./Batches_Label.vue?vue&type=template&id=84a08060&scoped=true"
import script from "./Batches_Label.vue?vue&type=script&lang=js"
export * from "./Batches_Label.vue?vue&type=script&lang=js"

import "./Batches_Label.vue?vue&type=style&index=0&id=84a08060&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84a08060"]])

export default __exports__